import React, { FC, useMemo } from "react";
import Animated, {
  Easing,
  useAnimatedProps,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withSpring,
  withTiming,
} from "react-native-reanimated";
import { Path, Svg } from "react-native-svg";
import { style as tickStyle } from "./Tick.style";

const AnimatedPath = Animated.createAnimatedComponent(Path);

const MIN_SCALE = 0.5;
// Geometric length of the polyline "M22.46 30.55 L27.8 36 L39.55 24" ≈ 24.42;
// rounded up to fully hide the stroke at the animation start.
const CHECK_PATH_LENGTH = 25;
const CHECK_DRAW_DELAY = 400;
const CHECK_DRAW_DURATION = 350;

const Tick: FC = () => {
  const style = useMemo(() => tickStyle(), []);

  const animation = useSharedValue(0);
  const draw = useSharedValue(CHECK_PATH_LENGTH);
  animation.value = withSpring(1);
  draw.value = withDelay(
    CHECK_DRAW_DELAY,
    withTiming(0, { duration: CHECK_DRAW_DURATION, easing: Easing.out(Easing.cubic) }),
  );

  const animatedStyles = useAnimatedStyle(
    () => ({
      opacity: animation.value,
      transform: [{ scale: MIN_SCALE + (1 - MIN_SCALE) * animation.value }],
    }),
    [animation],
  );

  const animatedCheckProps = useAnimatedProps(() => ({ strokeDashoffset: draw.value }), [draw]);

  return (
    <Animated.View style={[style.icon, animatedStyles]} testID="next-best-action-success-tick">
      <Svg fill="none" viewBox="0 0 61 60">
        <Path
          d="M8.5 30C8.5 17.8497 18.3497 8 30.5 8C42.6503 8 52.5 17.8497 52.5 30C52.5 42.1503 42.6503 52 30.5 52C18.3497 52 8.5 42.1503 8.5 30Z"
          fill={style.colorIconSuccess}
        />
        <AnimatedPath
          animatedProps={animatedCheckProps}
          d="M22.46 30.55 L27.8 36 L39.55 24"
          fill="none"
          stroke={style.colorBgBase}
          strokeDasharray={CHECK_PATH_LENGTH}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={4}
        />
      </Svg>
    </Animated.View>
  );
};

export { Tick };
